<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import _ from "lodash";
import Vue from 'vue'
import HostelContractPDF from "../../../../makepdfs/statement_hostel/stm_hostel_contract_pdf";

export default {
  name: "ConfComm",
  data: () => ({
    search_table: '',
    headers_table_state: [
      {text: 'ФИО', value: 'full_name', sortable: false},
      {text: 'ПРИЗНАК', value: 'privilege', align: "center", sortable: false, filterable: false},
      {
        text: 'СТАТУС',
        value: 'status_commission.status_review',
        align: "center",
        sortable: false,
        filterable: false
      },
      {text: 'ДАТА ОТПРАВЛЕНИЯ', value: 'created_at', sortable: false, filterable: false},
      {text: 'ДЕЙСТВИЯ', value: 'actions', sortable: false, align: "center", filterable: false},
    ],
    page: 1,
    pageCount: 0,
    drawer: false,
    items_list: [
      {icon: "fa fa-eye", color: "grey", name: "Подробнее"},
      {icon: "fa fa-check-circle", color: "green", name: "Подтвердить"},
      {icon: "fa fa-times-circle", color: "red", name: "Отклонить"},
    ],
    visb_dialog_approbation: false,
    option_dialog: null,
    comment_options: [
      {name: "Задолженность", icon: "fa-fax"},
      {name: "Выговор", icon: "fa fa-user-times"},
      {name: "Другое", icon: "fa fa-clone"}
    ],
    data_comment: {
      categories: null,
      text: ""
    },
    valid_form: true,
    selected_table: [],
    items_filter: [
      {
        color: 'orange',
        text: 'Рассматриваются',
      },
      {
        color: 'green',
        text: 'Одобренные',
      },
      {
        color: 'red',
        text: 'Отклоненные',
      },
    ],
    item_filter: null,
    drawer_left: false,
    count_conf: 0,
    count_rej: 0,
    count_rev: 0,
    data_approbation: {
      statement_hostel_id: null,
      status_approbation: '',
    }
  }),
  mounted() {
    this.GetListStatements().then(() => {
      this.updateCounters();
    });
  },
  watch: {
    categories: function (value) {
      if (value === 'Задолженность') {
        this.comment_text = 'Ваша задолженность составляет: '
      }
    },
    visb_dialog_approbation: function (value) {
      if (value === false) {
        this.categories = null
        this.comment_text = ''
      }
    },
    item_filter: function() {
      this.page = 1; // Сбрасываем страницу при изменении фильтра
    }
  },
  computed: {
    ...mapState({
      status_statements: state => state.interactionStatement.status_statements,
      list_statements: state => state.interactionStatement.list_statements,
      details_data_stm_hostel_for_other_commission: state => state.interactionStatement.details_data_stm_hostel_for_other_commission,
      status_conf: state => state.interactionStatement.status_conf,
      status_reject: state => state.interactionStatement.status_reject,
      comment_statement: state => state.interactionStatement.comment_statement,
      status_get_details_statement: state => state.interactionStatement.status_get_details_statement
    }),
    ...mapGetters({}),
    items_table() {
      if (this.item_filter !== null && this.items_filter[this.item_filter]?.text === 'Рассматриваются') {
        return _.filter(this.list_statements, (statement) => {
          return statement.status_commission.status_review === 1;
        });
      } else if (this.item_filter !== null && this.items_filter[this.item_filter]?.text === 'Одобренные') {
        return _.filter(this.list_statements, (statement) => {
          return statement.status_commission.status_review === 2;
        });
      } else if (this.item_filter !== null && this.items_filter[this.item_filter]?.text === 'Отклоненные') {
        return _.filter(this.list_statements, (statement) => {
          return statement.status_commission.status_review === 0 || statement.status_commission.status_review === 3;
        });
      }
      return this.list_statements;
    },
    facility(){
      return this.details_data_stm_hostel_for_other_commission?.facility
    },
    group(){
      return this.details_data_stm_hostel_for_other_commission?.group_name
    },
    rating(){
      return this.details_data_stm_hostel_for_other_commission?.rating
    },
    full_name(){
      return this.details_data_stm_hostel_for_other_commission?.full_name
    },
    privilege(){
      return this.details_data_stm_hostel_for_other_commission?.privilege
    },
    contract_id(){
      return this.details_data_stm_hostel_for_other_commission?.contract?.id
    },
    state_place_hostel() {
      return this.details_data_stm_hostel_for_other_commission?.place_hostel === "Неопредленное" ? false : this.details_data_stm_hostel_for_other_commission?.place_hostel
    },
    state_phone() {
      return this.details_data_stm_hostel_for_other_commission?.curr_phone
    },
    id_state() {
      return this.details_data_stm_hostel_for_other_commission?.id
    },
    state_rating() {
      return this.data_approbation.current_statement?.statement_hostel?.rating
    },
    curr_comment_categories() {
      return this.comment_statement.data_result.categories
    },
    curr_comment_text() {
      return this.comment_statement.review_comment
    },
    commission_id(){
      return this.details_data_stm_hostel_for_other_commission?.current_role_commission?.id
    },
    filterItems() {
      if (this.items_table) {
        if (this.search_table === null || this.search_table === "") return this.items_table

        return _.filter(this.items_table, item => {
          return item.statement_hostel.person.full_name.toLowerCase().includes(this.search_table.toLowerCase())
        })
      }
    },
  },
  methods: {
    ...mapMutations({
      setStatusConf: 'interactionStatement/setStatusConf',
      setStatusReject: 'interactionStatement/setStatusReject',
    }),
    ...mapActions({
      GetListStatements: 'interactionStatement/GetListStatements',
      GetDetailsStatementForOtherCommission: 'interactionStatement/GetDetailsStatementForOtherCommission',
      ConfStatement: 'interactionStatement/ConfStatement',
      RejectStatement: 'interactionStatement/RejectStatement',
      ShowCommentStatement: 'interactionStatement/ShowCommentStatement'
    }),
    updateCounters() {
      this.count_rev = _.filter(this.list_statements, {status_commission: {status_review: 1}}).length;
      this.count_conf = _.filter(this.list_statements, {status_commission: {status_review: 2}}).length;
      this.count_rej = _.filter(this.list_statements, (item) =>
          item.status_commission.status_review === 0 || item.status_commission.status_review === 3
      ).length;
    },
    viewContractHostel(){
      HostelContractPDF.createPDF(
          this.details_data_stm_hostel_for_other_commission.contract.data.full_name,
          this.details_data_stm_hostel_for_other_commission.contract.data.name_hostel,
          this.details_data_stm_hostel_for_other_commission.contract.data.name_section,
          this.details_data_stm_hostel_for_other_commission.contract.data.name_room,
          this.details_data_stm_hostel_for_other_commission.contract.data.registration_address,
          this.details_data_stm_hostel_for_other_commission.contract.data.identity_card,
          this.details_data_stm_hostel_for_other_commission.contract.data.selected_devices
      )
    },
    async confStatement() {
      await this.ConfStatement(this.data_approbation)

      this.visb_dialog_approbation = false
      this.updateStatus()
    },
    async rejectStatement() {
      if (this.$refs.form_comment.validate()) {
        await this.RejectStatement({
          data_approbation: this.data_approbation,
          data_comment: this.data_comment
        })

        this.visb_dialog_approbation = false
        this.updateStatus()
      }
    },
    updateStatus() {
      if (this.status_conf) {
        let current_conf_statement = _.find(this.list_statements, (statement) => {
          return statement.id === this.data_approbation.statement_hostel_id
        });

        current_conf_statement.status_commission.status_review = 2;

        this.setStatusConf(false);
        this.data_approbation.statement_hostel_id = null;
        this.data_approbation.status_approbation = '';
      }
      if (this.status_reject) {
        let current_rej_statement = _.find(this.list_statements, (statement) => {
          return statement.id === this.data_approbation.statement_hostel_id
        });

        current_rej_statement.status_commission.status_review = 3;

        this.data_approbation.current_statement = {};
        this.data_approbation.status = {};
      }
      this.setStatusReject(false);
      this.updateCounters();
    },
    menuMethods(item, item_name) {
      if (item_name === "Подробнее") {
        this.GetDetailsStatementForOtherCommission(item.id)

        this.ShowCommentStatement(item.id)

        this.drawer = !this.drawer
      }
      if (item_name === "Подтвердить") {
        this.option_dialog = true
        this.GetDetailsStatementForOtherCommission(item.id)

        this.data_approbation.statement_hostel_id = item.id
        this.data_approbation.status_approbation = 'confirmation'

        this.visb_dialog_approbation = true
      }
      if (item_name === "Отклонить") {
        this.option_dialog = false
        this.GetDetailsStatementForOtherCommission(item.id)

        this.data_approbation.statement_hostel_id = item.id
        this.data_approbation.status_approbation = 'rejection'

        this.visb_dialog_approbation = true
      }
    },
    setStatus(current_status) {
      if (current_status === 1) {
        return {color: 'orange', name: 'Рассматривается'}
      } else if (current_status === 2) {
        return {color: 'green', name: 'Одобрено'}
      } else if (current_status === 3) {
        return {color: 'red', name: 'Отклонено'}
      }
    },
    remove() {
      this.data_comment.categories = null
      this.data_comment.text = ''
    },
  }
}
</script>

<template>
  <v-app>
    <v-main>
      <v-container fluid>
        <v-card rounded="xl" max-height="800px" outlined>
          <v-card-title>
            <h6 class="text-sm-h4 text-h6 mx-auto">Список заявлений</h6>
          </v-card-title>
        </v-card>
        <v-row no-gutters>
          <v-col md="4" cols="12">
            <v-card rounded="xl" class="mt-5" outlined>
              <v-card-text class="d-flex justify-space-between">
                <div>
                  <span class="text-subtitle-1">Подтвержденные заявления</span>
                  <div class="d-flex align-center">
                    <h6 class="text-h5 font-weight-bold green--text">{{ count_conf }}</h6>
                  </div>
                  <span class="text-sm">Количество одобренных заявлений</span>
                </div>
                <div>
                  <v-avatar
                      color="green lighten-4"
                      rounded
                      size="53"
                  >
                    <v-icon color="green">fa-user-check</v-icon>
                  </v-avatar>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col md="4" cols="12">
            <v-card rounded="xl" class="mt-5 ml-2" outlined>
              <v-card-text class="d-flex justify-space-between">
                <div>
                  <span class="text-subtitle-1">Отклоненные заявления</span>
                  <div class="d-flex align-center">
                    <h6 class="text-h5 font-weight-bold red--text">{{ count_rej }}</h6>
                  </div>
                  <span class="text-sm">Количество неодобренных заявлений</span>
                </div>
                <div>
                  <v-avatar
                      color="red lighten-4"
                      rounded
                      size="53"
                  >
                    <v-icon color="red">fa fa-user-times</v-icon>
                  </v-avatar>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col md="4" cols="12">
            <v-card rounded="xl" class="mt-5 ml-2" outlined>
              <v-card-text class="d-flex justify-space-between">
                <div>
                  <span class="text-subtitle-1">Рассматриваемые заявления</span>
                  <div class="d-flex align-center">
                    <h6 class="text-h5 font-weight-bold orange--text">{{ count_rev }}</h6>
                  </div>
                  <span class="text-sm">Количество рассматриваемых заявлений</span>
                </div>
                <div>
                  <v-avatar
                      color="orange lighten-4"
                      rounded
                      size="53"
                  >
                    <v-icon color="orange">fa-user-clock</v-icon>
                  </v-avatar>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-card rounded="xl" min-height="500px" max-height="800px" outlined class="mt-5 overflow-hidden">
          <v-data-table
              v-model="selected_table"
              show-select
              :headers="headers_table_state"
              :items="items_table"
              :search="search_table"
              :items-per-page="12"
              :page.sync="page"
              :sort-by="['privilege','rating','created_at']"
              :sort-desc="[false, true, true]"
              :loading="status_statements"
              loading-text="Загрузка заявлений... пожалуйста подождите"
              @page-count="pageCount = $event"
              no-data-text="По предложенным критериям данные отсутствуют"
              hide-default-footer
              mobile-breakpoint="0"
          >
            <template v-slot:top>
              <v-app-bar
                  elevation="0"
              >
                <v-app-bar-nav-icon @click.stop="drawer_left = !drawer_left">
                  <template v-slot:default>
                    <v-icon small>
                      fa-bars
                    </v-icon>
                  </template>
                </v-app-bar-nav-icon>

                <v-spacer></v-spacer>

                <v-text-field
                    v-model="search_table"
                    label="Поиск"
                    dense
                    outlined
                    hide-details
                    clearable
                    @click:clear="search_table = ''"
                >
                  <template v-slot:prepend>
                    <v-icon size="20px">
                      fa-search
                    </v-icon>
                  </template>
                </v-text-field>
              </v-app-bar>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-menu
                  rounded="lg"
                  offset-y
                  left
                  origin="top right"
                  transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      x-small
                      icon
                      v-bind="attrs"
                      v-on="on"
                  >
                    <v-icon
                        size="15px"

                    >
                      fa-ellipsis-v
                    </v-icon>
                  </v-btn>
                </template>

                <v-list class="ma-0">
                  <v-list-item
                      v-for="(item_list, index) in items_list" :key="index"
                      @click="menuMethods(item, item_list.name)"
                      link
                      dense
                      class="px-0"
                  >
                    <v-list-item-avatar class="ma-0">
                      <v-icon small :color="item_list.color">
                        {{ item_list.icon }}
                      </v-icon>
                    </v-list-item-avatar>
                    <v-list-item-title class="pr-2">{{ item_list.name }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
            <template v-slot:item.status_commission.status_review="{ item }">
              <v-chip
                  small
                  rounded
                  elevation="0"
                  :color="setStatus(item.status_commission.status_review).color"
                  outlined
              >
                {{ setStatus(item.status_commission.status_review).name }}
              </v-chip>
            </template>
            <template v-slot:item.privilege="{ item }">
              <v-icon
                  v-if="item.privilege === 'Отсутствует' || item.privilege === 'отсутствует'"
                  size="20px"
              >
                fa-universal-access
              </v-icon>
              <v-icon
                  v-else
                  size="20px"
                  color="green"
              >
                fa-universal-access
              </v-icon>
            </template>
            <template v-slot:item.index="{ index }">
              {{ index + 1 }}
            </template>
          </v-data-table>
          <v-card-actions>
            <v-pagination
                class="mx-auto"
                v-model="page"
                :length="pageCount"
                total-visible="8"
                color="teal"
                circle
            ></v-pagination>
          </v-card-actions>
          <v-navigation-drawer
              class="rounded-xl"
              v-model="drawer_left"
              touchless
              absolute
              temporary
          >
            <v-card elevation="0" height="100%">
              <v-card-title>
                <h6 class="text-h6 mx-auto">Фильтр заявлений</h6>
                <div class="d-flex justify-end">
                  <v-btn icon @click="drawer_left = !drawer_left">
                    <v-icon size="15px">
                      fa-chevron-left
                    </v-icon>
                  </v-btn>
                </div>
              </v-card-title>

              <v-divider/>

              <v-list flat dense class="ml-1">
                <v-list-item-group
                    v-model="item_filter"
                    :active-class="'border'"
                    color="teal"
                >
                  <v-list-item
                      v-for="(item, i) in items_filter"
                      :key="i"
                  >
                    <v-list-item-icon>
                      <v-icon x-small :color="item.color">fa-circle</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                      <v-list-item-title v-text="item.text"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
          </v-navigation-drawer>
          <v-navigation-drawer
              height="100%"
              class="rounded-xl"
              width="400px"
              v-model="drawer"
              right
              touchless
              absolute
              temporary
          >
            <v-card
                width="100%"
                height="100%"
                v-if="status_get_details_statement"
                elevation="0"
            >
              <div style="height: 100%" class="d-flex justify-center align-center">
                <v-progress-circular
                    indeterminate
                    color="teal"
                    width="4"
                    size="100"
                ></v-progress-circular>
              </div>
            </v-card>

            <v-card
                v-else
                elevation="0"
            >
              <v-card-title>
                <v-btn absolute icon @click="drawer = !drawer">
                  <v-icon size="15px">
                    fa-chevron-left
                  </v-icon>
                </v-btn>
                <div class="mx-auto text-subtitle-1">
                  {{ full_name }}
                </div>
              </v-card-title>

              <v-divider/>

              <v-card-text>
                <template v-if="commission_id === 2">
                  <div class="text-uppercase">Договор на проживание</div>
                  <div class="mt-2">
                    <v-btn
                        @click="viewContractHostel"
                        color="teal"
                        small
                        outlined
                        rounded
                    >
                      Просмотр
                      <v-icon right>
                        fa-file
                      </v-icon>
                    </v-btn>
                  </div>
                </template>
                <div v-if="state_place_hostel">
                  <div class="mt-3 text-uppercase">Предложенные места</div>
                  <v-list
                      nav
                      disabled
                      rounded
                      flat
                  >
                    <v-list-item v-for="(place, index) in state_place_hostel" :key="index">
                      <v-list-item-avatar>
                        <v-icon>
                          fa-bed
                        </v-icon>
                      </v-list-item-avatar>
                      <v-list-item-title>{{ place.name_hostel + " " + place.name_room }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </div>
                <div class="text-uppercase">Отличительный признак</div>
                <h6 class="text--primary text-subtitle-1 mt-2"> {{ privilege }} </h6>
                <div class="mt-4 text-uppercase">Группа</div>
                <h6 class="text--primary text-subtitle-1 mt-2"> {{ group }} </h6>
                <div class="mt-4 text-uppercase">РАУ</div>
                <h6 class="text--primary text-subtitle-1 mt-2"> {{ rating }} </h6>
                <div class="mt-4 text-uppercase">Факультет</div>
                <h6 class="text--primary text-subtitle-1 mt-2"> {{ facility }} </h6>
                <div class="mt-4 text-uppercase">Номер телефона</div>
                <h6 class="text--primary text-subtitle-1 mt-2"> {{ state_phone }} </h6>
                <div v-if="Object.keys(comment_statement).length > 0">
                  <div class="mt-4 text-uppercase">Комментарий</div>
                  <h6 class="text--primary text-subtitle-1 mt-2"> {{ 'Тип комментария: ' + curr_comment_categories }} </h6>
                  <h6 class="text--primary text-subtitle-1 mt-2"> {{ curr_comment_text }} </h6>
                </div>
              </v-card-text>
            </v-card>
          </v-navigation-drawer>
        </v-card>

        <v-dialog
            v-model="visb_dialog_approbation"
            width="500"
        >
          <v-card
              rounded="xl"
              width="100%"
              height="300px"
              v-if="status_get_details_statement"
              elevation="0"
          >
            <div style="height: 100%" class="d-flex justify-center align-center">
              <v-progress-circular
                  indeterminate
                  color="teal"
                  width="4"
                  size="100"
              ></v-progress-circular>
            </div>
          </v-card>
          <v-card
              v-else
              class="transition-fast-in-fast-out v-card--reveal overflow-auto scrollable-card"
              style="height: 100%;"
              rounded="xl"
              elevation="0"
          >
            <v-card-title class="sticky-title pb-0">
              <v-row no-gutters>
                <v-spacer/>
                <v-btn
                    icon
                    @click="visb_dialog_approbation = !visb_dialog_approbation"
                >
                  <v-icon size="20">
                    fa-times
                  </v-icon>
                </v-btn>
                <v-col cols="12" class="text-center">
                  <div v-if="option_dialog" class="text-md-h5 text-sm-h6">Подтверждение заявления</div>
                  <div v-else class="text-md-h5 text-sm-h6">Отклонение заявления</div>
                </v-col>
                <v-col class="mt-2" cols="12">
                  <v-divider/>
                </v-col>
              </v-row>
            </v-card-title>

            <v-card-text class="mt-4 pb-0">
              <table class="text-subtitle-1">
                <tr>
                  <td class="pe-4">Номер заявления:</td>
                  <td>#{{ id_state }}</td>
                </tr>
                <tr>
                  <td class="pe-4">ФИО:</td>
                  <td>{{ full_name }}</td>
                </tr>
                <tr>
                  <td class="pe-4">Рейтинг:</td>
                  <td>{{ rating }}</td>
                </tr>
                <tr>
                  <td class="pe-4">Отличительный признак:</td>
                  <td>{{ privilege }}</td>
                </tr>
                <tr v-if="commission_id === 2">
                  <td class="pe-4">Номер договора:</td>
                  <td>№{{ contract_id }}</td>
                </tr>
              </table>

              <v-divider class="my-4"/>
              <v-form
                  v-if="!option_dialog"
                  ref="form_comment"
                  v-model="valid_form"
              >
                <v-autocomplete
                    v-model="data_comment.categories"
                    :items="comment_options"
                    :rules="[v => !!v || 'Необходимо выбрать тему']"
                    dense
                    outlined
                    chips
                    small-chips
                    item-text="name"
                    item-value="name"
                    label="Тема комментария"
                >
                  <template v-slot:selection="data">
                    <v-chip
                        class="my-2"
                        v-bind="data.attrs"
                        close
                        @click:close="remove()"
                    >
                      <v-avatar left>
                        <v-icon size="15px"> {{ data.item.icon }}</v-icon>
                      </v-avatar>
                      {{ data.item.name }}
                    </v-chip>
                  </template>
                </v-autocomplete>

                <v-textarea
                    v-model="data_comment.text"
                    :rules="[v => !!v || 'Комментарий пуст', v => (v && v.length <= 250) || 'Комментарий привысил лимит символов']"
                    :counter="250"
                    outlined
                    name="input-7-4"
                    label="Комментарий"
                    :value="data_comment.text"
                ></v-textarea>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-btn
                  @click="confStatement()"
                  v-if="option_dialog"
                  small
                  class="mx-auto"
                  color="green"
                  outlined
                  rounded
              >
                Одобрить
              </v-btn>
              <v-btn
                  v-if="!option_dialog"
                  @click="rejectStatement()"
                  small
                  class="mx-auto"
                  color="teal"
                  outlined
                  rounded
              >
                Отправить
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </v-main>
  </v-app>
</template>

<style scoped>
.border {
  border-left: 3px solid teal;
  margin-left: -3px;
}
</style>